import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const inputerCptsTransaction = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      loadingAcquirer: false,
      loadingIssuer: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      allAcquirer: null,
      allIssuer: null,
      totalPage: 0,

      requestData: null,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingAcquirer(state, loadingAcquirer) {
      state.loadingAcquirer = loadingAcquirer;
    },

    setLoadingIssuer(state, loadingIssuer) {
      state.loadingIssuer = loadingIssuer;
    },

    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setAcquirer(state, payload) {
      state.allAcquirer = payload;
    },

    setIssuer(state, payload) {
      state.allIssuer = payload;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'rrn'} ${sort}`;

      if (search.trx_datetime.length == 2) {
        const d1 = Date.parse(search.trx_datetime[0]);
        const d2 = Date.parse(search.trx_datetime[1]);

        if (d1 > d2) {
          const [trxDate1, trxDate2] = search.trx_datetime;
          // eslint-disable-next-line no-param-reassign
          search.trx_datetime[1] = trxDate1;
          // eslint-disable-next-line no-param-reassign
          search.trx_datetime[0] = trxDate2;
        }
      }

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/inputer-cpts-transaction/index`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getDetail(ctx, { id, date }) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/inputer-cpts-transaction/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setItem', { payload: responseData });
      }
    },
  },
};
export default inputerCptsTransaction;
